<template>
	<UITopHeading>Moeglichmacher</UITopHeading>
	<div class="container mb-20 grid grid-cols-1 gap-8 md:grid-cols-2">
		<p class="text-lg">
			Wir bedanken uns herzlich bei all unseren Freund*innen und
			Möglichmacher*innen, die das Festival Fürs Ehrenamt möglich machen. Jeder
			Beitrag zählt und hilft uns, das Festival zu einem unvergesslichen
			Erlebnis zu machen. Gemeinsam setzen wir uns für die Förderung des
			Ehrenamts ein und schaffen eine Plattform für den Austausch und die
			Vernetzung von Ehrenamtlichen.
		</p>
		<div
			class="bg-darkGreen relative flex flex-col self-center justify-self-center p-6 text-center"
			style="border-radius: 43% 57% 62% 38% / 32% 52% 48% 68%"
		>
			<span
				class="heading-font mx-4 my-4 text-3xl font-bold text-white md:text-4xl lg:text-5xl"
			>
				VIELEN
			</span>
			<span
				class="heading-font mb-4 text-3xl font-bold text-white md:text-4xl lg:text-5xl"
			>
				DANK
			</span>
			<div
				class="bg-brightGreen absolute inset-0 -z-10"
				style="border-radius: 51% 49% 39% 61% / 49% 41% 59% 51%"
			></div>
		</div>
	</div>
	<div class="container">
		<SponsorsTheSponsors />
	</div>

	<UIWaveSeparator background-color="brightRed" />

	<!-- Contact section -->
	<div class="container mt-16 grid grid-cols-1 gap-8 md:grid-cols-2">
		<h2 class="mt-0 text-xl font-bold md:text-3xl">
			Werdet auch Moeglichmacher*innen oder unterstützt uns
		</h2>
		<div>
			<p class="mb-6 max-w-prose">
				Du möchtest unser Festival unterstützen? Kontaktiere uns für mehr
				Informationen zu Sponsoringmöglichkeiten oder sonstiger Unterstützung.
				Wir freuen uns über jede Form der Unterstützung, sei es finanziell,
				materiell oder durch ehrenamtliche Mitarbeit.
			</p>
			<UButton
				to="mailto:info@propellerfestival.de"
				class="hover:text-brightestGreen"
			>
				Kontakt aufnehmen
			</UButton>
		</div>
	</div>
</template>

<script setup lang="ts">
useSeoMeta({
	title: 'Unterstützer',
	ogTitle: 'Unterstützer',
	twitterTitle: 'Unterstützer',
	description:
		'Unsere Möglichmacher und Partner, die das Festival Fürs Ehrenamt möglich machen.',
	ogDescription:
		'Unsere Möglichmacher und Partner, die das Festival Fürs Ehrenamt möglich machen.',
	twitterDescription:
		'Unsere Möglichmacher und Partner, die das Festival Fürs Ehrenamt möglich machen.',
	ogUrl: 'https://propellerfestival.de/sponsoren',
})
</script>
